export interface CurrencyConversionConfig {
  baseCurrencyCode?: string;
  rates?: Record<string, number>;
}

export function formatCurrency(amount: number | null | undefined, currencyCode = 'USD'): string {
  if (amount === null || amount === undefined || Number.isNaN(amount)) {
    return '-';
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatCompactCurrency(amount: number | null | undefined, currencyCode = 'USD'): string {
  if (amount === null || amount === undefined || Number.isNaN(amount)) {
    return '-';
  }

  const absAmount = Math.abs(amount);
  if (absAmount >= 1_000_000) {
    return `${formatCurrency(amount / 1_000_000, currencyCode)}M`;
  }

  if (absAmount >= 1_000) {
    return `${formatCurrency(amount / 1_000, currencyCode)}K`;
  }

  return formatCurrency(amount, currencyCode);
}

export function convertCurrency(
  amount: number | null | undefined,
  fromCurrency: string | null | undefined,
  toCurrency: string | null | undefined,
  config: CurrencyConversionConfig
): number | null {
  if (amount === null || amount === undefined || Number.isNaN(amount)) {
    return null;
  }

  const source = (fromCurrency || config.baseCurrencyCode || 'USD').toUpperCase();
  const target = (toCurrency || config.baseCurrencyCode || 'USD').toUpperCase();
  if (source === target) {
    return amount;
  }

  const rates = config.rates || {};
  const baseCurrencyCode = (config.baseCurrencyCode || 'USD').toUpperCase();
  const sourceRate = source === baseCurrencyCode ? 1 : rates[source];
  const targetRate = target === baseCurrencyCode ? 1 : rates[target];

  if (!sourceRate || !targetRate) {
    return amount;
  }

  const baseAmount = source === baseCurrencyCode ? amount : amount / sourceRate;
  return target === baseCurrencyCode ? baseAmount : baseAmount * targetRate;
}